import { createReducer, on } from '@ngrx/store';
import * as TeamsActions from '../actions/teams.actions';


export interface State {
    teams: any[];
    errorMessage: string | null;
    isLoading: boolean;
}

export const initialState: State = {
    teams: [],
    errorMessage: null,
    isLoading: false
};

export const teamsReducer = createReducer(
    initialState,

    on(TeamsActions.loadTeams, (state) => ({
        ...state,
        isLoading: true,
        errorMessage: null
    })),

    on(TeamsActions.loadTeamsSuccess, (state, { teams }) => ({
        ...state,
        teams: teams,
        isLoading: false,
        errorMessage: null
    })),

    on(TeamsActions.loadTeamsFailure, (state, { error }) => ({
        ...state,
        isLoading: false,
        errorMessage: error
    }))
);